import exportIcon from '@disy/cadenza-icons/export.svg';
import { logger } from '@disy/lib/logging';
import { icon } from '@disy/ui/icon';

import { Action } from 'cadenza/action';
import { ACTIONS } from 'cadenza/actions/actions-config';
import type { View } from 'cadenza/workbook/view/view';
import i18n from 'cadenza/workbook/view/view-header/actions/print-map-action.properties';
import { getMap } from 'cadenza/workbook/view/view-util';

export class PrintMapAction extends Action {
  readonly #view: View;

  constructor(view: View) {
    super({ id: ACTIONS.MAP.WORKBOOK_PRINT_MAP, label: i18n('action.label'), icon: icon(exportIcon) });
    this.#view = view;
  }

  override execute() {
    return import('cadenza/workbook/export-georeferenced-image-dialog/export-georeferenced-image-dialog')
      .then(({ ExportGeoreferencedImageDialog }) =>
        new ExportGeoreferencedImageDialog(getMap(this.#view)).connectAndShow(),
      )
      .catch((error) => logger.error('Failed to show workbook print map dialog.', error));
  }
}
